<template>
  <div 
    class="pa-5">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        
        <section>

          <v-card 
            flat
            class="mt-0"
            style="background: #fff;">
            <v-card-text class="pa-5">
          
              <div class="black--text fs-20 mb-2 font-weight-bold">
                Mengubah Kategori
              </div>

              <ValidationObserver 
                ref="form">
                <v-form>
                  <v-row>
                    <v-col
                      cols="12"
                      md="6">
                      <ValidationProvider
                        name="Nama Kategori Pegawai" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="fs-15 label-input mb-2">
                          Nama Kategori Pegawai
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense
                          solo

                          :color="set_color"
                          placeholder="Contoh. Admin"

                          
                          :item-color="set_color"

                          v-model="form.title"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <div>
                    <div class="fs-15 label-input mb-2">
                      Hak Akses
                    </div>

                    <div
                      style="height: calc(100vh - 390px); overflow-y: auto;">
                      <v-treeview
                        dense
                        open-all
                        open-on-click

                        selectable
                        :selected-color="set_color"

                        rounded
                        transition

                        :items="list"
                        item-key="id"
                        item-text="title"

                        item-children="sub_menu"
                        
                        return-object
                        class="non_border_tree"
                        
                        v-model="form.menu_arr">
                        <template v-slot:prepend="{ item }">
                          <!-- <v-img v-if="item.icon !== undefined"
                            width="20"
                            height="20"
                            alt="kominfoklaten"  
                            :src="item.icon"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="18"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img> -->
                          <v-icon v-if="item.icon !== undefined"
                            size="18">
                            {{ item.icon }}
                          </v-icon>

                          <v-icon v-else
                            size="18">
                            mdi-minus-thick
                          </v-icon>
                        </template>
                      </v-treeview>
                    </div>
                  </div>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
              <v-row
                justify="end"
                class="pa-4 pb-1 pr-1">
                <v-col 
                  cols="12"
                  md="12"
                  class="d-flex align-center justify-end py-0">
                  <v-btn 
                    @click="save()"
                    :loading="process.form"
                    :disabled="process.form"
                    width="190"
                    height="45"
                    elevation="0"
                    color="#6948c6"
                    class="fs-16 white--text text-capitalize border-radius">
                    Simpan
                  </v-btn>
                  
                  <v-btn
                    to="/user/category"
                    :disabled="process.form"
                    color="red"
                    elevation="0"
                    width="140"
                    height="45"
                    class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                    style="font-weight: 600;">
                  
                      Batal
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>



          <!-- <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
            </v-col>
          </v-row> -->
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          snackbar: false
        },

        role: [
          {
            id: 1,
            name: 'Admin'
          },
          {
            id: 2,
            name: 'Pegawai' 
          }
        ],
        list:[
        { 
                      id: 1,
                      title: 'User',
                      icon: "mdi-badge-account-outline",
                      color: "primary",
                      link: '/user',
                      active: false,
                      sub_menu: [
                        {
                          id: 2,
                          title: 'Staff',
                          link: '/user/staff',
                          icon: "mdi-badge-account-outline",
                          color: "primary",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 3,
                          title: 'Supplier',
                          link: '/user/supplier',
                          icon: "mdi-badge-account-outline",
                          color: "primary",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 4,
                          title: 'Kategori Staff',
                          link: '/user/category',
                          icon: "mdi-badge-account-outline",
                          color: "primary",
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    },
                    {
                      id: 10,
                      title: 'Sales',
                      icon: 'mdi-account-tie',
                      color: "pink",
                      link: '/sales',
                      active: false,
                      sub_menu: [
                        {
                          id: 11,
                          title: 'sales',
                          link: '/sales/staff',
                          icon: 'mdi-account-tie',
                          color: "pink",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 12,
                          title: 'Kode Sales (Area Sales)',
                          link: '/sales/code',
                          icon: 'mdi-account-tie',
                          color: "pink",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 13,
                          title: 'Target Sales',
                          link: '/sales/target',
                          icon: 'mdi-account-tie',
                          color: "pink",
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    },
                    {
                      id: 6,
                      title: 'Customer',
                      icon: 'mdi-account-group',
                      color: "success",
                      link: '/customer/data',
                      active: false,
                      sub_menu: [
                      {
                          id: 7,
                          title: 'Customer Saya',
                          link: '/customer/data',
                          icon: 'mdi-account-group',
                          color: "success",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 59,
                          title: 'Pengajuan Customer',
                          link: '/customer/proses',
                          icon: 'mdi-account-group',
                          color: "success",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 60,
                          title: 'Proses Pengajuan',
                          link: '/customer/acc',
                          icon: 'mdi-account-group',
                          color: "success",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 61,
                          title: 'Histori Rejected',
                          link: '/customer/reject',
                          icon: 'mdi-account-group',
                          color: "success",
                          active: false,
                          sub_menu: [],
                        },
                        // {
                        //   id: 8,
                        //   title: 'Toko',
                        //   link: '/customer/toko',
                        //   active: false,
                        //   sub_menu: [],
                        // },
                        {
                          id: 8,
                          title: 'Perubahan Plafon',
                          link: '/customer/plafon',
                          icon: 'mdi-account-group',
                          color: "success",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 9,
                          title: 'Perubahan Customer',
                          link: '/customer/perubahan',
                          icon: 'mdi-account-group',
                          color: "success",
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    },
                    {
                      id: 14,
                      title: 'Produk',
                      icon: 'mdi-package-variant',
                      color: "warning",
                      link: '/product',
                      active: false,
                      sub_menu: [
                        {
                          id: 15,
                          title: 'Data Produk',
                          link: '/product/data',
                          icon: 'mdi-package-variant',
                          color: "warning",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 16,
                          title: 'Varian Produk',
                          link: '/product/varian',
                          icon: 'mdi-package-variant',
                          color: "warning",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 17,
                          title: 'Kategori Produk',
                          link: '/product/category_product',
                          icon: 'mdi-package-variant',
                          color: "warning",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 18,
                          title: 'Group Produk',
                          link: '/product/group',
                          icon: 'mdi-package-variant',
                          color: "warning",
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    },
                  {
                    id: 41,
                    title: 'Stok',
                    icon: 'mdi-text-box-check',
                    color: "#00838F",
                    link: '/stok',
                    active: false,
                    sub_menu: [
                      {
                        id: 42,
                        title: 'Stok',
                        link: '/stok/data',
                        icon: 'mdi-text-box-check',
                        color: "#00838F",
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 43,
                        title: 'Stok In Order',
                        link: '/stok/in-order',
                        icon: 'mdi-text-box-check',
                        color: "#00838F",
                        active: false,
                        sub_menu: [],
                      }
                    ],
                  },
                    {
                      id: 22,
                      title: 'Kelola Visit',
                      icon: 'mdi-map-marker',
                      color: "#00838F",
                      link: '/visit',
                      active: false,
                      sub_menu: [
                        {
                          id: 23,
                          title: 'Laporan Visit',
                          link: '/visit/data',
                          icon: 'mdi-map-marker',
                          color: "#00838F",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 78,
                          title: 'Laporan Visit Detail',
                          link: '/visit/laporan',
                          icon: 'mdi-map-marker',
                          color: "#00838F",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 24,
                          title: 'Buat Jadwal Visit',
                          link: '/visit/jadwal',
                          icon: 'mdi-map-marker',
                          color: "#00838F",
                          active: false,
                          sub_menu: [],
                        },
                      ],
                    },
                    {
                      id: 25,
                      title: 'Presensi',
                      icon: 'mdi-fingerprint',
                      color: "#BF360C",
                      link: '/presensi',
                      active: false,
                      sub_menu: [
                        {
                          id: 26,
                          title: 'Laporan Presensi',
                          link: '/presensi/data',
                          icon: 'mdi-fingerprint',
                          color: "#BF360C",
                          active: false,
                          sub_menu: [],
                        },
                        {
                          id: 27,
                          title: 'Laporan Ijin',
                          link: '/presensi/ijin',
                          icon: 'mdi-fingerprint',
                          color: "#BF360C",
                          active: false,
                          sub_menu: [],
                        }
                      ],
                    },
                    {
                    id: 28,
                    title: 'Pembelian',
                    icon: 'mdi-cart-arrow-down',
                    color: "#827717",
                    link: '/pengajuan',
                    active: false,
                    sub_menu: [
                      {
                        id: 29,
                        title: 'Permintaan Stok',
                        link: '/pengajuan/pembelian-warehouse',
                        icon: 'mdi-cart-arrow-down',
                        color: "#827717",
                        active: false,
                        sub_menu: [],
                      },
                      // {
                      //   id: 64,
                      //   title: 'Permintaan Barang',
                      //   link: '/pengajuan/permintaan-barang',
                      //   icon: 'mdi-cart-arrow-down',
                      //   color: "#827717",
                      //   active: false,
                      //   sub_menu: [],
                      // },
                      {
                        id: 30,
                        title: 'Permintaan GM',
                        link: '/pengajuan/pembelian-general-manager',
                        icon: 'mdi-cart-arrow-down',
                        color: "#827717",
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 31,
                        title: 'Penerimaan Stok',
                        link: '/pengajuan/penerimaan/data',
                        icon: 'mdi-cart-arrow-down',
                        color: "#827717",
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 32,
                        title: 'QC Barang',
                        link: '/pengajuan/qc',
                        icon: 'mdi-cart-arrow-down',
                        color: "#827717",
                        active: false,
                        sub_menu: [],
                      }
                    ],
                  },
                  {
                    id: 44,
                    title: 'Order',
                    icon: 'mdi-order-bool-descending-variant',
                    color: "#455A64",
                    link: '/approval',
                    active: false,
                    sub_menu: [
                    {
                        id: 45,
                        title: 'Approval Order',
                        link: '/approval/order',
                        icon: 'mdi-order-bool-descending-variant',
                        color: "#455A64",
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 46,
                        title: 'Approval Order Warehouse',
                        link: '/approval/order-warehouse',
                        icon: 'mdi-order-bool-descending-variant',
                        color: "#455A64",
                        active: false,
                        sub_menu: [],
                      }
                    ],
                  },

                  {
                    id: 65,
                    title: 'Pengajuan Barang',
                    icon: 'mdi-text-box-plus',
                    color: "#4A148C",
                    link: '/pengajuan-barang',
                    active: false,
                    sub_menu: [
                    {
                        id: 66,
                        title: 'Data Pengajuan',
                        link: '/pengajuan-barang/data',
                        icon: 'mdi-text-box-plus',
                        color: "#4A148C",
                        active: false,
                        sub_menu: [],
                      },
                    {
                        id: 67,
                        title: 'Approval Atasan',
                        link: '/pengajuan-barang/approval-atasan',
                        icon: 'mdi-text-box-plus',
                        color: "#4A148C",
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 68,
                        title: 'Approval General Manager',
                        link: '/pengajuan-barang/approval-general-manager',
                        icon: 'mdi-text-box-plus',
                        color: "#4A148C",
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 69,
                        title: 'Penerimaan Barang',
                        link: '/pengajuan-barang/approval-gudang',
                        icon: 'mdi-text-box-plus',
                        color: "#4A148C",
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 73,
                        title: 'Update harga & Pilih Supplier',
                        link: '/pengajuan-barang/update-harga-supplier',
                        icon: 'mdi-text-box-plus',
                        color: "#4A148C",
                        active: false,
                        sub_menu: [],
                      }
                    ],
                  },

                  {
                    id: 70,
                    title: 'Pembayaran Barang',
                    icon: 'mdi-basket-plus',
                    color:'#1B5E20',
                    active: false,
                    sub_menu: [
                      {
                        id: 71,
                        title: 'Kasir',
                        link: '/pembayaran-barang/kasir',
                        icon: 'mdi-basket-plus',
                        color:'#1B5E20',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 72,
                        title: 'Akunting',
                        link: '/pembayaran-barang/akunting',
                        icon: 'mdi-basket-plus',
                        color:'#1B5E20',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 74,
                        title: 'Approval Finance Manager',
                        link: '/pembayaran-barang/manager-keuangan',
                        icon: 'mdi-basket-plus',
                        color:'#1B5E20',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 75,
                        title: 'Approval General Manager',
                        link: '/pembayaran-barang/general-manager',
                        icon: 'mdi-basket-plus',
                        color:'#1B5E20',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 76,
                        title: 'Print Kasir',
                        link: '/pembayaran-barang/print-kasir',
                        icon: 'mdi-basket-plus',
                        color:'#1B5E20',
                        active: false,
                        sub_menu: [],
                      }
                    ]
                  },

                  {
                    id: 48,
                    title: 'Pengiriman',
                    icon: 'mdi-gift',
                    color:'#006064',
                    link: '/delivery',
                    active: false,
                    sub_menu: [
                    {
                        id: 49,
                        title: 'Buat BPB',
                        link: '/delivery/bpb',
                        icon: 'mdi-gift',
                        color:'#006064',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 50,
                        title: 'Buat Surat Jalan',
                        link: '/delivery/surat-jalan',
                        icon: 'mdi-gift',
                        color:'#006064',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 77,
                        title: 'Proses Muat',
                        link: '/delivery/proses-muat',
                        icon: 'mdi-gift',
                        color:'#006064',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 51,
                        title: 'Konfirmasi Pengiriman',
                        icon: 'mdi-gift',
                        color:'#006064',
                        link: '/konfirmasi-pengirirman',
                        active: false,
                        sub_menu: [],
                      },

                  {
                      id: 58,
                      title: 'Retur',
                      icon: 'mdi-gift',
                      color:'#006064',
                      link: '/retur',
                      active: false,
                      sub_menu: [], 
                    },
                    ],
                  },


                  {
                    id: 52,
                    title: 'Promo',
                    icon: 'mdi-percent-circle',
                    color:'#B71C1C',
                    link: '/promo',
                    active: false,
                    sub_menu: [
                    {
                        id: 53,
                        title: 'Data Promo',
                        link: '/promo/data',
                        icon: 'mdi-percent-circle',
                        color:'#B71C1C',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 54,
                        title: 'Banner',
                        link: '/promo/banner',
                        icon: 'mdi-percent-circle',
                        color:'#B71C1C',
                        active: false,
                        sub_menu: [],
                      }
                    ],
                  },

                  {
                    id: 33,
                    title: 'Finance',
                    icon: 'mdi-book-open-page-variant',
                    color:'#4A148C',
                    link: '/finance',
                    active: false,
                    sub_menu: [
                    {
                        id: 34,
                        title: 'Data Penerimaan Stok',
                        link: '/finance/penerimaan/data',
                        icon: 'mdi-book-open-page-variant',
                        color:'#4A148C',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 35,
                        title: 'Close PO',
                        link: '/finance/po/data',
                        icon: 'mdi-book-open-page-variant',
                        color:'#4A148C',
                        active: false,
                        sub_menu: [],
                      },
                      // {
                      //   id: 36,
                      //   title: 'Bank',
                      //   link: '/finance/bank',
                      //   icon: 'mdi-book-open-page-variant',
                      //   color:'#4A148C',
                      //   active: false,
                      //   sub_menu: [],
                      // },
                      {
                        id: 36,
                        title: 'Invoice Supplier',
                        link: '/finance/invoice-supplier',
                        icon: 'mdi-book-open-page-variant',
                        color:'#4A148C',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 37,
                        title: 'Invoice Customer',
                        link: '/finance/invoice',
                        icon: 'mdi-book-open-page-variant',
                        color:'#4A148C',
                        active: false,
                        sub_menu: [],
                      },
                      // {
                      //   id: 62,
                      //   title: 'Approval Permintaan Barang',
                      //   link: '/finance/pengajuan',
                      //   icon: 'mdi-book-open-page-variant',
                      //   color:'#4A148C',
                      //   active: false,
                      //   sub_menu: [],
                      // }
                    ],
                  },
                  {
                    id: 38,
                    title: 'Kasir',
                    icon: 'mdi-printer-pos',
                    icon_color: '#E65100',
                    link: '/kasir',
                    active: false,
                    sub_menu: [
                      {
                        id: 39,
                        title: 'Kasir Customer',
                        link: '/kasir/customer',
                        icon: 'mdi-printer-pos',
                        icon_color: '#E65100',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 40,
                        title: 'Kasir Supplier',
                        link: '/kasir/supplier',
                        icon: 'mdi-printer-pos',
                        icon_color: '#E65100',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 63,
                        title: 'Pembukuan Permintaan Barang',
                        link: '/kasir/pembukuan',
                        icon: 'mdi-printer-pos',
                        icon_color: '#E65100',
                        active: false,
                        sub_menu: [],
                      }
                    ],
                  },
                  {
                    id: 55,
                    title: 'Pengaturan',
                    icon: 'mdi-cog',
                    color: 'black',
                    link: '/master',
                    active: false,
                    sub_menu: [
                      {
                        id: 5,
                        title: 'Cabang',
                        icon: 'mdi-cog',
                        color: 'black',
                        link: '/cabang',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 47,
                        title: 'Vehicle',
                        icon: 'mdi-cog',
                        color: 'black',
                        link: '/vehicle/data',
                        active: false,
                        sub_menu: [],
                      },
                    {
                        id: 56,
                        title: 'Bank',
                        link: '/master/bank',
                        icon: 'mdi-cog',
                        color: 'black',
                        active: false,
                        sub_menu: [],
                      },
                      {
                        id: 57,
                        title: 'Config',
                        link: '/master/config',
                        icon: 'mdi-cog',
                        color: 'black',
                        active: false,
                        sub_menu: [],
                      },
                    ],
                  },

        ],

        form: {
          id: '',
          title: '',
          menu_arr: []
        },

        process: {
          load: false,

          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      // 'form.id': function() {
      //   let t = this

      //   let r = this.role.filter(function(v) {
      //     return t.form.id == v.id
      //   })

      //   if (r.length > 0) {
      //     this.form.title = r[0].name
          
      //     // this.fetchRole()
      //   }
      // }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    beforeMount () {
      // this.fetchRole()
      this.fetch()
    },
    mounted () {
      
    },
    methods: {
      // async fetchRole () {
      //   await get('admin/menu_privilege/data')
      //   .then(response => {
      //     let res = response.data
            
      //     if (res.status === 200) {
      //       this.role = res.results.data

      //       if (this.form.id === '') this.form.id = this.role.length > 0 ? this.role[0].id : ''

      //       if (this.form.id !== '') this.fetch()
      //     }
      //   })
      // },

      async fetch () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        this.form.menu_arr = []

        await get('admin/category_user/data', { params })
        .then(response => {
          let res = response.data

          this.process.laod = false
            
          if (res.status === 200) {
            this.form.id = res.results.data[0].id
            this.form.title = res.results.data[0].title
            let data = res.results.data.length > 0 ? JSON.parse(res.results.data[0].menu_arr) : []
            console.log(data)

            data.map(obj => {
              if (!obj.link.includes('/user') && !obj.link.includes('/sales') && !obj.link.includes('/product') && !obj.link.includes('/customer') && !obj.link.includes('/visit') && !obj.link.includes('/presensi') && !obj.link.includes('/pengajuan') && !obj.link.includes('/finance') && !obj.link.includes('/approval') && !obj.link.includes('/stok') && !obj.link.includes('/delivery') && !obj.link.includes('/kasir') && !obj.link.includes('/promo') && !obj.link.includes('/master') && !obj.link.includes('/pengajuan-barang') && !obj.link.includes('/pembayaran-barang')) {
                this.form.menu_arr.push(obj)
              } else {
                if (obj.link.includes('/user')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/sales')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/customer')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/product')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/visit')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/presensi')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/pengajuan')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/finance')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/approval')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/stok')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/delivery')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/kasir')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/promo')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                console.log(obj.link.includes('/master'))
                if (obj.link.includes('/master')) {
                  console.log('test')
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/pengajuan-barang')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }

                if (obj.link.includes('/pembayaran-barang')) {
                  obj.sub_menu.map(obj_sub => {
                    this.form.menu_arr.push(obj_sub)
                  })
                }
              }
            })

            this.form.menu_arr.sort((a, b) => a.id - b.id)
          }
        })
      },

      array_parent () {
        let menu_arr = this.form.menu_arr, menu_fix  = []

        menu_arr.map(obj => {
          if (!obj.link.includes('/user/') && !obj.link.includes('/sales/') && !obj.link.includes('/product/') && !obj.link.includes('/customer') && !obj.link.includes('/visit') && !obj.link.includes('/presensi') && !obj.link.includes('/pengajuan') && !obj.link.includes('/finance') && !obj.link.includes('/approval') && !obj.link.includes('/stok') && !obj.link.includes('/delivery') && !obj.link.includes('/kasir') && !obj.link.includes('/promo') && !obj.link.includes('/master') && !obj.link.includes('/pengajuan-barang') && !obj.link.includes('/pembayaran-barang')) {
            menu_fix.push(obj)
          } else {

            if (obj.link.includes('/kasir/')) {
              menu_fix.push({
                id: 38,
                title: 'Kasir',
                icon: 'mdi-printer-pos',
                icon_color: '#E65100',
                link: '/kasir',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/promo/')) {
              menu_fix.push({
                id: 52,
                title: 'Promo',
                icon: 'mdi-percent-circle',
                color:'#B71C1C',
                link: '/promo',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/user/')) {
              menu_fix.push({
                id: 1,
                title: 'User',
                icon: "mdi-badge-account-outline",
                      color: "primary",
                link: '/user',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/sales/')) {
              menu_fix.push({
                id: 10,
                title: 'Sales',
                icon: 'mdi-account-tie',
                      color: "pink",
                link: '/sales',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/customer/')) {
              menu_fix.push({
                id: 6,
                title: 'Customer',
                icon: 'mdi-account-group',
                      color: "success",
                link: '/customer',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/visit/')) {
              menu_fix.push({
                id: 22,
                title: 'Kelola Visit',
                      icon: 'mdi-map-marker',
                      color: "#00838F",
                link: '/visit',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/presensi/')) {
              menu_fix.push({
                id: 25,
                title: 'Presensi',
                icon: 'mdi-fingerprint',
                      color: "#BF360C",
                link: '/presensi',
                active: false,
                sub_menu: []
              })
            }

            

            if (obj.link.includes('/pengajuan/')) {
              menu_fix.push({
                id: 28,
                title: 'Pembelian',
                icon: 'mdi-cart-arrow-down',
                    color: "#827717",
                link: '/pengajuan',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/product/')) {
              menu_fix.push({
                id: 14,
                title: 'Produk',
                icon: 'mdi-package-variant',
                      color: "warning",
                link: '/product',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/finance/')) {
              menu_fix.push({
                id: 33,
                title: 'Finance',
                icon: 'mdi-book-open-page-variant',
                    color:'#4A148C',
                link: '/finance',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/approval/')) {
              menu_fix.push({
                id: 44,
                title: 'Order',
                icon: 'mdi-order-bool-descending-variant',
                    color: "#455A64",
                link: '/approval',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/stok/')) {
              menu_fix.push({
                id: 41,
                title: 'Stok',
                icon: 'mdi-text-box-check',
                    color: "#00838F",
                link: '/stok',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/delivery/')) {
              menu_fix.push({
                id: 48,
                title: 'Pengiriman',
                    icon: 'mdi-gift',
                    color:'#006064',
                link: '/delivery',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/master/')) {
              menu_fix.push({
                id: 55,
                title: 'Pengaturan',
                    icon: 'mdi-cog',
                    color: 'black',
                link: '/master',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/pengajuan-barang/')) {
              menu_fix.push({
                id: 65,
                title: 'Pengajuan Barang',
                    icon: 'mdi-text-box-plus',
                    color: "#4A148C",
                link: '/pengajuan-barang',
                active: false,
                sub_menu: []
              })
            }

            if (obj.link.includes('/pembayaran-barang/')) {
              menu_fix.push({
                id: 70,
                title: 'Pembayaran Barang',
                icon: 'mdi-basket-plus',
                color:'#1B5E20',
                link: '/pembayaran-barang',
                active: false,
                sub_menu: []
              })
            }


          }
        })

        menu_fix = this.array_same(menu_fix)

        return menu_fix
      },
      array_same (arr) {
        let result = arr.reduce((unique, o) => {
            if(!unique.some(obj => obj.id === o.id)) {
              unique.push(o)
            }
            return unique
        },[])

        return result.sort((a, b) => a.id - b.id)
      },
      array_final () {
        let menu_form = this.form.menu_arr, menu_fix = this.array_parent()
        
        menu_form.map(obj => {
          menu_fix.map(obj_sub => {
            if (obj.link.includes('/user/') && obj_sub.link === '/user') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/sales/') && obj_sub.link === '/sales') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/customer/') && obj_sub.link === '/customer') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/visit/') && obj_sub.link === '/visit') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/presensi/') && obj_sub.link === '/presensi') {
              obj_sub.sub_menu.push(obj)
            }

            // if (obj.link.includes('/peta/') && obj_sub.link === '/peta') {
            //   obj_sub.sub_menu.push(obj)
            // }

            if (obj.link.includes('/product/') && obj_sub.link === '/product') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/pengajuan/') && obj_sub.link === '/pengajuan') {
              obj_sub.sub_menu.push(obj)
            }
            
            if (obj.link.includes('/finance/') && obj_sub.link === '/finance') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/approval/') && obj_sub.link === '/approval') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/stok/') && obj_sub.link === '/stok') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/delivery/') && obj_sub.link === '/delivery') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/kasir/') && obj_sub.link === '/kasir') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/promo/') && obj_sub.link === '/promo') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/master/') && obj_sub.link === '/master') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/pengajuan-barang/') && obj_sub.link === '/pengajuan-barang') {
              obj_sub.sub_menu.push(obj)
            }

            if (obj.link.includes('/pembayaran-barang/') && obj_sub.link === '/pembayaran-barang') {
              obj_sub.sub_menu.push(obj)
            }
          })
        })

        return menu_fix
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          console.log(this.array_final())

          this.form.menu_arr = JSON.stringify(this.array_final())

          // this.form.menu_arr = JSON.stringify(this.list)

          // SAVE TO REST API
          await post('admin/category_user/update', {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message
              this.$router.push({ path: '/user/category' })

              // this.fetchRole()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>